import { render, staticRenderFns } from "./providerSignup.vue?vue&type=template&id=fec41774&scoped=true"
import script from "./providerSignup.vue?vue&type=script&lang=js"
export * from "./providerSignup.vue?vue&type=script&lang=js"
import style0 from "./providerSignup.vue?vue&type=style&index=0&id=fec41774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec41774",
  null
  
)

export default component.exports